import {
  createApi,
  defaultSerializeQueryArgs,
} from '@reduxjs/toolkit/query/react';

import { Tags } from '~/api/atlas/tags.autogen';

import { extractRtkQueryRehydrationInfo } from '../rehydrate';
import { extractQueryOptions } from '../utils';
import { atlasBaseQuery } from './baseQuery';

const FIVE_MINUTES = 5 * 60;

export const ATLAS_API_REDUCER_PATH = 'api/atlas' as const;

export const atlasApiRoot = createApi({
  reducerPath: ATLAS_API_REDUCER_PATH,
  baseQuery: atlasBaseQuery,
  keepUnusedDataFor: FIVE_MINUTES,
  refetchOnFocus: false,
  serializeQueryArgs: (args) => {
    const { payload } = extractQueryOptions(args.queryArgs);
    return defaultSerializeQueryArgs({ ...args, queryArgs: payload });
  },
  tagTypes: Object.values(Tags),
  extractRehydrationInfo: extractRtkQueryRehydrationInfo,
  endpoints: () => ({}),
});
